import styled from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS, SIZING } from '../../styles/variables';

export const Container = styled.div`
  display: flex;
  padding-top: ${SIZING.unit(1.5)};
  padding-bottom: ${SIZING.unit(6)};
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  flex: 1 0 0;
  @media (${device.tablet}) {
    gap: 8px;
    padding-bottom: ${SIZING.unit(7.75)};
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Title = styled.div`
  font-family: Audi Type;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  color: ${COLORS.error};
  @media (${device.tablet}) {
    font-size: 16px;
    line-height: 24px;
  }
  @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
    font-size: 12px;
    line-height: 20px;
  }
`;

export const Message = styled.div`
  font-family: Audi Type;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
  color: ${COLORS.error};
  @media (${device.tablet}) {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.003px;
  }
  @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
    font-size: 12px;
    line-height: 20px;
  }
  padding-left: ${SIZING.unit(4.5)};
`;
